import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

// 2FA kapali hesapla giris yapilinca bir kez gosterilen oneri (2 Kas 2026: sifreleri ele gecirilen hesaplar).
// Login saga'si 2FA kapaliysa sessionStorage'a TWO_FACTOR_PROMPT_KEY yazar; bu bilesen gosterip siler.
// 2FA, Hesap sayfasindan (pages/account/users.js) authenticator uygulamasiyla aciliyor.
export const TWO_FACTOR_PROMPT_KEY = 'dt_2fa_prompt';

function readFlag() {
	try {
		return window.sessionStorage.getItem(TWO_FACTOR_PROMPT_KEY) === '1';
	} catch (e) {
		return false;
	}
}
function clearFlag() {
	try {
		window.sessionStorage.removeItem(TWO_FACTOR_PROMPT_KEY);
	} catch (e) {
		// storage kapali olabilir
	}
}

export default function TwoFactorPrompt() {
	const { t } = useTranslation();
	const [open, setOpen] = React.useState(readFlag);
	const close = () => {
		clearFlag();
		setOpen(false);
	};
	if (!open) return null;
	return (
		<Modal open size="tiny" onClose={close} closeIcon>
			<Modal.Header>
				<Icon name="shield alternate" color="blue" /> {t('twoFactorPromptTitle', 'Protect your account with two-factor authentication')}
			</Modal.Header>
			<Modal.Content>
				<p>
					{t(
						'twoFactorPromptText',
						'Two-factor authentication is not enabled on your account. Even if your password is stolen, a code from an authenticator app (Google Authenticator, Microsoft Authenticator, etc.) keeps others out.'
					)}
				</p>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={close}>{t('twoFactorPromptLater', 'Remind me later')}</Button>
				<Button primary as={Link} to="/account" onClick={close}>
					{t('twoFactorPromptEnable', 'Enable 2FA')}
				</Button>
			</Modal.Actions>
		</Modal>
	);
}
